import React from "react";
import {Box, Stack, Toolbar, Typography} from "@mui/material";
import {Link} from "react-router-dom";
import {FitrLogoLink} from "../../../components/links/FitrLogoLink";
import brandMark from "../../../assets/logo.svg";
import {c} from "../../landing/landingTokens";
import {a, linkSx, panelSx} from "./authStyles";

// Shared shell of the auth pages, in the registry-project style: soft pastel page, one white panel (no header bar).
// Panel: small kicker (what this is), title, one sentence saying what to do, the form (children), and an
// optional line to switch to the other page (prompt + linkText). `banner` renders above the kicker.
export const AuthLayout = ({
                             maxWidth = 420, banner, kicker, title, description, prompt, linkText, linkTo,
                             preserveSearch = true, children
                           }) => {
  return (
    <Box sx={{
      position: "relative", width: "100%", minHeight: "100%", display: "flex", flexDirection: "column", bgcolor: a.bg,
      // soft static pastel wash (lavender, blush, sky) - no motion
      backgroundImage: [
        "radial-gradient(ellipse 60% 50% at 12% 8%, rgba(199, 210, 254, 0.55), transparent 70%)",
        "radial-gradient(ellipse 50% 45% at 92% 20%, rgba(250, 213, 235, 0.5), transparent 70%)",
        "radial-gradient(ellipse 55% 50% at 70% 100%, rgba(191, 226, 250, 0.5), transparent 70%)",
      ].join(", "),
      backgroundAttachment: "fixed",
    }}>
      {/* top left corner: the purple mark, same logo + name as the landing header, links to the home page (/) */}
      <Box component={Link} to={"/"} aria-label={"OpenBrain home"} sx={{
        position: "absolute", top: 20, left: 24, display: "inline-flex", alignItems: "center", gap: 1.1,
        color: c.ink, textDecoration: "none",
      }}>
        <Box component={"img"} src={brandMark} alt={""} sx={{width: 20, height: 24, objectFit: "contain"}}/>
        <Typography sx={{fontSize: 18, fontWeight: 700, letterSpacing: "-0.035em", color: "inherit"}}>OpenBrain</Typography>
      </Box>

      {/* PANEL */}
      <Box sx={{flex: 1, display: "flex", alignItems: "center", justifyContent: "center", px: 2, py: 4}}>
        <Stack gap={3} sx={{
          ...panelSx, maxWidth, width: "100%", boxSizing: "border-box", px: {xs: 2.5, sm: 4}, py: {xs: 3, sm: 4}
        }}>
          {banner}

          <Box>
            {kicker && (
              <Typography sx={{fontSize: 11, fontWeight: 600, letterSpacing: "0.12em", textTransform: "uppercase", color: a.accent}}>
                {kicker}
              </Typography>
            )}
            <Typography component={"h1"} sx={{
              mt: 0.5, fontSize: {xs: 22, sm: 24}, fontWeight: 700, letterSpacing: "-0.02em", lineHeight: 1.2, color: a.ink,
            }}>
              {title}
            </Typography>
            {description && (
              <Typography sx={{mt: 0.75, fontSize: 14, lineHeight: 1.5, color: a.muted}}>{description}</Typography>
            )}
          </Box>

          {children}

          {linkText && (
            <Typography sx={{textAlign: "center", fontSize: 13.5, color: a.muted}}>
              {prompt}{" "}
              <Link to={`${linkTo}${preserveSearch ? window.location.search : ""}`} style={{...linkSx, textDecoration: "none"}}>
                {linkText}
              </Link>
            </Typography>
          )}
        </Stack>
      </Box>

      {/* FOOTER */}
      <Toolbar sx={{justifyContent: "flex-end"}}>
        <FitrLogoLink/>
      </Toolbar>
    </Box>
  );
};
